import { Mark } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    customItalic: {
      /**
       * Toggle custom italic styling with data-spotstyle
       */
      toggleCustomItalic: (isActive: boolean, value: string) => ReturnType;
      /**
       * Set custom italic mark
       */
      setCustomItalic: (name: string, value: string) => ReturnType;
      /**
       * Unset custom italic mark
       */
      unsetCustomItalic: () => ReturnType;
      /**
       * Unset italic styling
       */
      unsetItalic: () => ReturnType;
    };
  }
}

export const CustomItalic = Mark.create({
  name: 'customItalic',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      'data-spotstyle': {
        default: null,
        parseHTML: (element) => element.getAttribute('data-spotstyle'),
        renderHTML: (attributes) => {
          if (!attributes['data-spotstyle']) return {};
          return { 'data-spotstyle': attributes['data-spotstyle'] };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span',
      },
      {
        tag: 'i',
        getAttrs: (node) => (node as HTMLElement).style.fontStyle !== 'normal' && null,
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', { ...this.options.HTMLAttributes, ...HTMLAttributes }, 0];
  },

  addCommands() {
    return {
      setCustomItalic: (name, value) => {
        return ({ commands }) => {
          return commands.setMark(name, { 'data-spotstyle': value });
        };
      },
      unsetCustomItalic: () => {
        return ({ commands }) => {
          return commands.unsetMark(this.name);
        };
      },
      unsetItalic: () => {
        return ({ commands }) => {
          return commands.unsetMark(this.name);
        };
      },
      toggleCustomItalic: (isActive: boolean, value: string) => {
        return ({ editor }) => {
          if (isActive) {
            return editor.chain().focus().unsetItalic().setCustomItalic('customItalic', value).run();
          }

          return editor.chain().focus().setItalic().unsetCustomItalic().run();
        };
      },
    };
  },
});
